import React, { useEffect, useState, createRef } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Draggable from "react-draggable";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import TextField from "@material-ui/core/TextField";
import { green, orange, red, grey } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import AdditionalSeatsComp from "../Views/AdditionalSeatsComp.jsx";
import axios from "axios";

const ModalAdditionalSeats = (props) => {
    const change = (e) => {
        e.preventDefault();
    };

    const styleMainRim = {
        border: "3px solid #de210b",
        borderRadius: "10px",
        margin: "5px",
    };

    const styleMainForm = {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-around",
        flexWrap: "wrap",
    };

    useEffect(() => {
        axios
            .get("/manager/data/hotels/show_add/" + props.rateId)
            .then((response) => {
                if (response.data != "") props.setData(response.data);
            })
            .catch((error) => alert(error));
    }, []);

    return (
        <div>
            <Dialog
                open={props.isOpen}
                onClose={props.onClose}
                aria-labelledby="draggable-dialog-title"
                maxWidth="xl"
            >
                <DialogTitle
                    style={{ cursor: "move" }}
                    id="draggable-dialog-title"
                >
                    Редактирование доп. мест
                </DialogTitle>
                <div>
                    <div style={styleMainForm}>
                        <div style={styleMainRim}>
                            <h3
                                style={{
                                    textAlign: "center",
                                    fontWeight: "900",
                                }}
                            >
                                <b>{props.names[0]}</b>
                            </h3>
                            {props.data[props.namesIdAdds[0]] &&
                                props.data[props.namesIdAdds[0]].map(
                                    (aS, idx) => (
                                        <AdditionalSeatsComp
                                            el={aS}
                                            idx={idx}
                                            key={props.namesIdAdds[0] + idx}
                                            start_name={
                                                props.namesIdAdds[0] + "_start"
                                            }
                                            end_name={
                                                props.namesIdAdds[0] + "_end"
                                            }
                                            price_name={
                                                props.namesIdAdds[0] + "_price"
                                            }
                                            add={props.add}
                                            del={props.del}
                                            sign={props.namesIdAdds[0]}
                                        />
                                    ),
                                )}
                        </div>

                        <div style={styleMainRim}>
                            <h3
                                style={{
                                    textAlign: "center",
                                    fontWeight: "900",
                                }}
                            >
                                <b>{props.names[1]}</b>
                            </h3>
                            {props.data[props.namesIdAdds[1]] &&
                                props.data[props.namesIdAdds[1]].map(
                                    (aS, idx) => (
                                        <AdditionalSeatsComp
                                            el={aS}
                                            idx={idx}
                                            key={aS.id}
                                            start_name={
                                                props.namesIdAdds[1] + "_start"
                                            }
                                            end_name={
                                                props.namesIdAdds[1] + "_end"
                                            }
                                            price_name={
                                                props.namesIdAdds[1] + "_price"
                                            }
                                            add={props.add}
                                            del={props.del}
                                            sign={props.namesIdAdds[1]}
                                        />
                                    ),
                                )}
                        </div>

                        <div style={styleMainRim}>
                            <h3
                                style={{
                                    textAlign: "center",
                                    fontWeight: "900",
                                }}
                            >
                                <b>{props.names[2]}</b>
                            </h3>
                            {props.data[props.namesIdAdds[2]] &&
                                props.data[props.namesIdAdds[2]].map(
                                    (aS, idx) => (
                                        <AdditionalSeatsComp
                                            el={aS}
                                            idx={idx}
                                            key={props.namesIdAdds[2] + idx}
                                            start_name={
                                                props.namesIdAdds[2] + "_start"
                                            }
                                            end_name={
                                                props.namesIdAdds[2] + "_end"
                                            }
                                            price_name={
                                                props.namesIdAdds[2] + "_price"
                                            }
                                            add={props.add}
                                            del={props.del}
                                            sign={props.namesIdAdds[2]}
                                        />
                                    ),
                                )}
                        </div>

                        <div style={styleMainRim}>
                            <h3
                                style={{
                                    textAlign: "center",
                                    fontWeight: "900",
                                }}
                            >
                                <b>{props.names[3]}</b>
                            </h3>
                            {props.data[props.namesIdAdds[3]] &&
                                props.data[props.namesIdAdds[3]].map(
                                    (aS, idx) => (
                                        <AdditionalSeatsComp
                                            el={aS}
                                            idx={idx}
                                            key={props.namesIdAdds[3] + idx}
                                            start_name={
                                                props.namesIdAdds[3] + "_start"
                                            }
                                            end_name={
                                                props.namesIdAdds[3] + "_end"
                                            }
                                            price_name={
                                                props.namesIdAdds[3] + "_price"
                                            }
                                            add={props.add}
                                            del={props.del}
                                            sign={props.namesIdAdds[3]}
                                        />
                                    ),
                                )}
                        </div>

                        <div style={styleMainRim}>
                            <h3
                                style={{
                                    textAlign: "center",
                                    fontWeight: "900",
                                }}
                            >
                                <b>{props.names[4]}</b>
                            </h3>
                            {props.data[props.namesIdAdds[4]] &&
                                props.data[props.namesIdAdds[4]].map(
                                    (aS, idx) => (
                                        <AdditionalSeatsComp
                                            el={aS}
                                            idx={idx}
                                            key={props.namesIdAdds[4] + idx}
                                            start_name={
                                                props.namesIdAdds[4] + "_start"
                                            }
                                            end_name={
                                                props.namesIdAdds[4] + "_end"
                                            }
                                            price_name={
                                                props.namesIdAdds[4] + "_price"
                                            }
                                            add={props.add}
                                            del={props.del}
                                            sign={props.namesIdAdds[4]}
                                        />
                                    ),
                                )}
                        </div>
                    </div>

                    <div style={styleMainForm}>
                        <Button
                            onClick={props.onClose}
                            color="primary"
                            variant="contained"
                            endIcon={<ArrowBackIcon />}
                            style={{
                                backgroundColor: orange[500],
                                margin: "10px",
                            }}
                        >
                            Отмена
                        </Button>
                        <Button
                            onClick={props.save}
                            color="primary"
                            variant="contained"
                            endIcon={<SaveIcon />}
                            style={{
                                backgroundColor: green[500],
                                margin: "10px",
                            }}
                        >
                            Сохранить
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default ModalAdditionalSeats;
